import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { selectDeeplinkToken, selectUserUuid } from '../signup/signupSlice';
import { setMetrics } from '../../analytics/eCommerce';
import { sendAnalyticsEvents } from '../../analytics/common';
import { EVENTS } from '../../analytics/events';
import { FBC_PARAM, FBP_PARAM, FB_PIXEL_ID } from '../../analytics/facebook';
import Cookies from 'js-cookie';
import { selectID, selectUpsellData } from '../checkout/checkoutSlice';
import { selectLandingType, selectPlan } from '../plans/plansSlice';
import { selectEventsData } from '../events/eventsSlice';
import { MediumTitle, fadeInAnimation, wh, screenPadding, fontSize } from '../../mixins';
import Logo from '../../UI/Logo';
import UIButton from '../../UI/UIButton';
import { isBrowser, isIOS, isAndroid } from 'react-device-detect';
import useWindowWidth from '../../helper/useWindowWidth';

const StyledContainer = styled.div`
  ${wh('100%')};
  ${isBrowser && fadeInAnimation};
  ${screenPadding};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
      margin: 0;
  }

  @media screen and (min-width: 768px) {
      padding: 24px 6px 32px;
      height: calc(100vh - 116px);

  }
`;

const QRCode = styled.div`
  background-color: #fff;
  padding: 20px 20px 17px 20px;
  border-radius: 29px;
  &>canvas {
    width: 200px;
    height: 200px;
  }
`


const QRTitle = styled.div`
  font-weight: 500;
  ${fontSize(18)};
  line-height: 25px;
  margin: 13px 0 32px;
  color:#fff;
  text-align: center;
`

const Title = styled.h1`
  ${MediumTitle};
  margin: 24px 0;
  text-transform: capitalize;
`;


const SuccessScreen = () => {
    const {t} = useTranslation();
    const plan = useSelector(selectPlan);
    const orderID = useSelector(selectID);
    const landingType = useSelector(selectLandingType);
    const eventsData = useSelector(selectEventsData);
    const upsellData = useSelector(selectUpsellData);
    const userUuid = useSelector(selectUserUuid);
    const windowWidth = useWindowWidth();
    const deepLinkToken = useSelector(selectDeeplinkToken);
    const oneLinkInitial = "https://family-locator.onelink.me/eb3y";
    const [oneLinkUrl, setOneLinkUrl] = useState(oneLinkInitial);

    useEffect(() => {
      if (!window.AF_SMART_SCRIPT) return;
      const fbc = Cookies.get(FBC_PARAM) || '';
      const fbp = Cookies.get(FBP_PARAM) || '';
      const AFUserID = Cookies.get('afUserId') || '';
      const resultLink = window.AF_SMART_SCRIPT.generateOneLinkURL({
          oneLinkURL: oneLinkInitial,
          afParameters: {
              mediaSource: {keys:["utm_source", "af_pid"], defaultValue: `${eventsData.utm_source || ""}`},
              campaign: {keys:["utm_campaign","af_c"], defaultValue: `${eventsData.utm.utm_campaign || eventsData.utm.af_c || ''}` },
              channel: {keys:["AdChannel","utm_medium","af_channel"], defaultValue: `${eventsData.utm.af_channel || ''}`},
              ad: {keys:["utm_ad", "af_ad","AdName",], defaultValue: `${eventsData.utm.utm_ad || eventsData.utm.af_ad || ''}`},
              adSet: {keys: ["utm_content" || "af_adset", "AdSetName"], defaultValue: `${eventsData.utm.utm_content || eventsData.utm.af_adset || ''}`},
              deepLinkValue: {keys:["deep_link_value"], defaultValue: `${eventsData.utm.deep_link_value || eventsData.deep_link_value || ''}`},
              afSub1: {keys:["af_sub1"], defaultValue: `${deepLinkToken}`},
              afSub2: {keys:["af_sub2", "fbclid"], defaultValue: '' },
              afSub3: {keys:["af_sub3"],defaultValue: `${FB_PIXEL_ID}`},
              afSub4: {keys:["af_sub4"],defaultValue: `${fbc};${fbp};${AFUserID}`},
              afSub5: {keys:["af_sub5"],defaultValue: encodeURI(window.navigator.userAgent)}
          }
      });
      setOneLinkUrl(`${resultLink.clickURL}&af_dp=family-locator-webtoapp://`)
      window.AF_SMART_SCRIPT.displayQrCode("qrcode");
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.AF_SMART_SCRIPT]);
  
    const onOneLinkBtnClick = () => {
      window.location.href = oneLinkUrl;
    };

    useEffect(() => sendAnalyticsEvents(EVENTS.successScreenShown, eventsData), [eventsData]);

    useEffect(() => {
        if (plan && orderID) {
            setMetrics(plan, orderID, upsellData?.success, landingType, userUuid);
        }
    }, [plan, orderID, upsellData, landingType, userUuid]);

    return (
        <StyledContainer windowWidth={windowWidth}>
            {windowWidth > 430 && <Logo/>}
            <Title>{t('your_plans_awaits')}</Title>
            {isIOS || isAndroid ? (
              <UIButton onClick={onOneLinkBtnClick}>{t('go_to_app')}</UIButton>
            ) : (
              <>
                <QRTitle>{t('scan_qr_code')}</QRTitle>
                <QRCode id="qrcode"></QRCode>
              </>
            )}
            <input type='hidden' id={'end-of-onboarding'} />
        </StyledContainer>
    )
};

export default SuccessScreen;
